import profile from         '@/lang/views/personal/profile';
import recipientFields from '@/lang/views/personal/recipientFields';
import transferList from    '@/lang/views/personal/transferList';
import transferDetail from  '@/lang/views/personal/transferDetail';
import billPage from        '@/lang/views/personal/billPage';
import billCreateForm from  '@/lang/views/personal/billCreateForm';
import dealCreateForm from  '@/lang/views/personal/dealCreateForm';
import dealDetail from      '@/lang/views/personal/dealDetail';
import dealsList from       '@/lang/views/personal/dealsList';
import verify from          './views/verify';
import bill from            '@/lang/views/bill';
import transfer from        '@/lang/views/transfer';

export default {
    en: {
        views: {
            personal: {
                profile: profile.en,
                recipientFields: recipientFields.en,
                transferList: transferList.en,
                transferDetail: transferDetail.en,
                billPage: billPage.en,
                billCreateForm: billCreateForm.en,
                dealsList: dealsList.en,
                dealCreateForm: dealCreateForm.en,
                dealDetail: dealDetail.en,
                
            },
            verify: verify.en,
            bill: bill.en,
            transfer: transfer.en
        }
    },
    ru: {
        views: {
            personal: {
                profile: profile.ru,
                recipientFields: recipientFields.ru,
                transferList: transferList.ru,
                transferDetail: transferDetail.ru,
                billPage: billPage.ru,
                billCreateForm: billCreateForm.ru,
                dealsList: dealsList.ru,
                dealCreateForm: dealCreateForm.ru,
                dealDetail: dealDetail.ru,
            },
            verify: verify.ru,
            bill: bill.ru,
            transfer: transfer.ru
        }
    }
}